/**
 * Compressão de fotos no aparelho antes de salvar/enfileirar.
 * Alvo: lado maior ≤ 1024px e ~250 KB por foto (JPEG), para subir rápido em sinal fraco.
 */
export const MAX_SIDE = 1024;
export const TARGET_BYTES = 250 * 1024;

export function dataUrlBytes(dataUrl) {
  if (!dataUrl) return 0;
  const i = dataUrl.indexOf(",");
  return Math.round(((dataUrl.length - i - 1) * 3) / 4);
}

export function fitScale(w, h, maxSide = MAX_SIDE) {
  const m = Math.max(w, h);
  return m > maxSide ? maxSide / m : 1;
}

export function canvasToCompressedJpeg(canvas, target = TARGET_BYTES) {
  let q = 0.75;
  let out = canvas.toDataURL("image/jpeg", q);
  while (dataUrlBytes(out) > target && q > 0.45) {
    q = Math.round((q - 0.1) * 100) / 100;
    out = canvas.toDataURL("image/jpeg", q);
  }
  return out;
}

// Decodifica e reduz a foto para ≤ MAX_SIDE já no decoder (createImageBitmap: rápido e sem base64 de 5 MB na memória).
// Fallback: <img> + canvas para navegadores sem suporte.
async function viaBitmap(file) {
  const probe = await createImageBitmap(file);
  const s = fitScale(probe.width, probe.height);
  const w = Math.round(probe.width * s), h = Math.round(probe.height * s);
  let bmp = probe;
  if (s < 1) {
    try { bmp = await createImageBitmap(file, { resizeWidth: w, resizeHeight: h, resizeQuality: "medium" }); probe.close(); }
    catch { bmp = probe; }
  }
  const c = document.createElement("canvas");
  c.width = w; c.height = h;
  c.getContext("2d").drawImage(bmp, 0, 0, w, h);
  bmp.close();
  return c;
}

function viaImageTag(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const s = fitScale(img.width, img.height);
      const c = document.createElement("canvas");
      c.width = Math.round(img.width * s); c.height = Math.round(img.height * s);
      c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      resolve(c);
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("Imagem inválida ou corrompida")); };
    img.src = url;
  });
}

export async function loadScaledCanvas(file) {
  if (!file || !file.type || !file.type.startsWith("image/")) throw new Error("Arquivo não é imagem");
  if (typeof createImageBitmap === "function") {
    try { return await viaBitmap(file); } catch { /* cai para <img> */ }
  }
  return viaImageTag(file);
}

export async function compressFile(file) {
  const c = await loadScaledCanvas(file);
  return canvasToCompressedJpeg(c);
}

export function fmtKB(bytes) {
  return bytes >= 1024 * 1024 ? `${(bytes / 1024 / 1024).toFixed(1)} MB` : `${Math.round(bytes / 1024)} KB`;
}
